/**
 * @generated SignedSource<<c9d590f256c47b2dadd998037740d221>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BuyerPreQuotedOptions_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerPreQuotedOption_transaction">;
  readonly " $fragmentType": "BuyerPreQuotedOptions_transaction";
};
export type BuyerPreQuotedOptions_transaction$key = {
  readonly " $data"?: BuyerPreQuotedOptions_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"BuyerPreQuotedOptions_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyerPreQuotedOptions_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerPreQuotedOption_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "a6e13695107e2e7f738c0f92d05a0ec3";

export default node;
